<template>
  <ion-toolbar>
    <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button class="pill next-pill-button" @click="skip">
        <span>Skip</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">

    <div class="container">
      <div class="auth-header">
        <div class="auth-heading">
          <h1>{{ pageText.pageTitle }}</h1>
        </div>
        <div class="brand-icon">
          <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
        </div>
      </div>
      <el-form class="full_page" :model="form" ref="userForm" label-position="top">

        <el-form-item :error="v$.minRate.$error" :show-message="false" class="no-scroll" :required="true"
          prop="minRate">
          <div class="inner-label">
            Weekday rate per hour
          </div>
          <div class="input-wrapper">
            <!-- <span class="el-input__prefix">
                $
              </span> -->
            <div class="el-input el-input--suffix">
              <input type="tel" class="input_currency el-input__inner" v-model="form.minRate" placeholder="0.00"
                @input="validateField('minRate')" @keyup="checkValue('minRate', $event)" />
              <span class="el-input__suffix">USD</span>
            </div>
          </div>
          <el-form-item-error v-if="v$.minRate.$error">{{ v$.minRate.$errors[0].$message
            }}</el-form-item-error>
        </el-form-item>
        <el-form-item :error="v$.weekendRate.$error" :show-message="false" class="no-scroll" :required="true"
          prop="weekendRate">
          <div class="inner-label">
            Weekend rate per hour
          </div>
          <div class="input-wrapper">
            <!-- <span class="el-input__prefix">
                $
              </span> -->
            <div class="el-input el-input--suffix">
              <input type="tel" class="input_currency el-input__inner" v-model="form.weekendRate" placeholder="0.00"
                @input="validateField('weekendRate')" @keyup="checkValue('weekendRate', $event)" />
              <span class="el-input__suffix">USD</span>
            </div>
          </div>
          <!-- <div class="input-wrapper">
              <span class="el-input__prefix">
                $
              </span>
              <el-input data-testid="directions-125" v-model="form.weekendRate" placeholder="0.00"
                @keyup="checkValue('weekendRate', $event)"
                @input="validateField('weekendRate')"></el-input>
            </div> -->
          <el-form-item-error v-if="v$.weekendRate.$error">{{
            v$.weekendRate.$errors[0].$message }}</el-form-item-error>
        </el-form-item>
        <!-- Button to submit the form -->
        <el-form-item class="button_submit mb0">
          <el-button class="submit" type="blue" data-testid="directions-126" :disabled="isSubmitDisabled"
            @click="handleSubmit">
            Continue
          </el-button>

        </el-form-item>
      </el-form>
      <div class="background-circles">
        <div class="circle circle-2"></div>
        <div class="circle circle-1"></div>
        <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed, inject, onMounted } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
// import { IonToolbar, IonButton, IonButtons, IonIcon } from '@ionic/vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from "vuex";
import { ElMessageBox } from "@/components/Vendor/Element";
import SvgIcon from '@/components/Svg/SvgIcon.vue';

// import { VueMaskDirective } from 'v-mask';

const setPageClassGlobal = inject(['setPageClassGlobal']);
const $router = useRouter();
const $store = useStore();
const $route = useRoute();

const userData = $store.getters.GET_USER_DATA;
const form = reactive({
  minRate: userData.minRate ? userData.minRate : '',
  weekendRate: userData.weekendRate ? userData.weekendRate : '',
  // Added rateType property
});

const pageText = {
  pageTitle: 'Rates',
  // formText: 'what are your salary expectations?',
};

// const { modelValue: model, unmask, mask } = VueMaskDirective();

const rules = computed(() => {
  return {
    minRate: {
      required: helpers.withMessage('Please enter the valid hourly rate', required),
      // Checks if the input is numeric with optional decimals
      numeric: helpers.withMessage(
        'Invalid number format',
        (value) => /^\d*(\.\d*)?$/.test(value)
      ),
      // Validator to ensure max 3 digits before the decimal, allowing an optional trailing decimal
      maxThreeDigitsBeforeDecimal: helpers.withMessage(
        'Only up to 3 digits are allowed before the decimal',
        (value) => /^\d{1,3}(\.\d*)?$/.test(value)
      ),
      // New validator to ensure there’s a digit after the decimal if a decimal is present
      // decimalRequiresFraction: helpers.withMessage(
      //   'If using a decimal, please enter at least one digit after the decimal',
      //   (value) => !value.includes('.') || /\.\d+/.test(value) // Pass if no decimal or if there's at least one digit after the decimal
      // ),
      // Validator to ensure max 2 digits after the decimal
      maxTwoDigitsAfterDecimal: helpers.withMessage(
        'Only up to 2 decimal places are allowed',
        (value) => /^\d*(\.\d{1,2})?$/.test(value)
      ),
    },
    weekendRate: {
      required: helpers.withMessage('Please enter the valid weekend rate', required),
      // Checks if the input is numeric with optional decimals
      numeric: helpers.withMessage(
        'Invalid number format',
        (value) => /^\d*(\.\d*)?$/.test(value)
      ),
      // Validator to ensure max 3 digits before the decimal, allowing an optional trailing decimal
      maxThreeDigitsBeforeDecimal: helpers.withMessage(
        'Only up to 3 digits are allowed before the decimal',
        (value) => /^\d{1,3}(\.\d*)?$/.test(value)
      ),
      // New validator to ensure there’s a digit after the decimal if a decimal is present
      // decimalRequiresFraction: helpers.withMessage(
      //   'If using a decimal, please enter at least one digit after the decimal',
      //   (value) => !value.includes('.') || /\.\d+/.test(value) // Pass if no decimal or if there's at least one digit after the decimal
      // ),
      // Validator to ensure max 2 digits after the decimal
      maxTwoDigitsAfterDecimal: helpers.withMessage(
        'Only up to 2 decimal places are allowed',
        (value) => /^\d*(\.\d{1,2})?$/.test(value)
      ),
    },
  };
});

const v$ = useVuelidate(rules, form);

const isSubmitDisabled = computed(() => {
  return Object.values(form).some(value => value === '') || v$.value.$pending || v$.value.$error;
});

// const setRateType = (type) => {
//   form.rateType = type;
//   validateField('rate'); // Trigger validation when rate type changes
// };

const validateField = (fieldName) => {
  // Trigger validation for the specified field
  v$.value[fieldName].$touch();
};

const checkValue = (fieldName, event) => {
  const value = event.target.value;
  const regex = /^\d{0,8}(\.\d{0,2})?$/;
  if (!regex.test(value)) {
    // If the entered value doesn't match the format, remove the last character
    form[fieldName] = value.slice(0, -1);
  } else {
    // Update the field's value with the validated value
    form[fieldName] = value;
  }
};

const goNext = () => {
  $router.push({
    name: 'auth_address',
  });
};

const handleSubmit = async () => {
  const result = await v$.value.$validate();
  if (!result) {
    alert('The form has errors');
    return;
  } (async () => {
    try {
      await $store.dispatch("SAVE_USER_DATA", form);
      goNext();
    } catch (error) {
      console.log("error submit!!");
    }
  })();
};
const goBack = () => {
  $router.push({
    name: 'welcome_contractor',
  });
};
onMounted(() => {
  setPageClassGlobal('global_auth_page');
  // validateField('minRate');
  // validateField('weekendRate');
});

const skip = () => {
  (async () => {
    try {
      await ElMessageBox.confirm(
        ``,
        "Do you want to skip? You will be unverified",
        {
          distinguishCancelAndClose: true,
          showConfirmButton: true,
          confirmButtonText: "Skip",
          cancelButtonText: "Cancel",
          confirmButtonClass: "el-button--green",
          cancelButtonClass: "el-button--grey",
          showClose: true,
        }
      );
    } catch {
      return;
    }
    try {
      await $store.dispatch("addAuthPageBack", $route.name);
      $router.push({
        name: "auth_address",
      });
    } catch (error) {
      console.log(error);
    }
  })();
};
</script>

<!-- <style scoped>
  .button-wrapper {
    display: flex;
    margin-bottom: 10px;
  }
  
  .button-wrapper .el-button {
    margin-right: 10px;
  }
  
  .input-wrapper {
    display: flex;
    align-items: center;
  }
  
  .input-wrapper .el-input__prefix {
    margin-right: 5px;
  }</style> -->